var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 17.3C51.3 20.4 52 23.6 52 27C52 30.4 51.3 33.6 50 36.7C48.7 39.8 46.9 42.4 44.7 44.7C42.5 46.9 39.8 48.7 36.7 50C33.6 51.3 30.4 52 27 52C23.6 52 20.4 51.3 17.3 50C14.2 48.7 11.6 46.9 9.3 44.7C7.1 42.5 5.3 39.8 4 36.7C2.7 33.6 2 30.4 2 27C2 23.6 2.7 20.4 4 17.3C5.3 14.2 7.1 11.6 9.3 9.3C11.5 7.1 14.2 5.3 17.3 4C20.4 2.7 23.6 2 27 2C30.4 2 33.6 2.7 36.7 4C39.8 5.3 42.4 7.1 44.7 9.3C46.9 11.6 48.6 14.3 50 17.3Z",
    fill: "#52a5d7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 38.5L39.2 19.2C39.4 18.4 39.3 17.8 38.9 17.4C38.5 17 38.1 17 37.5 17.2L13.4 26.5C12.9 26.7 12.5 26.9 12.3 27.2C12.1 27.5 12.1 27.7 12.2 27.9C12.3 28.1 12.6 28.3 13.1 28.4L19.3 30.3L33.6 21.3C34 21 34.3 21 34.5 21.1C34.6 21.2 34.6 21.3 34.4 21.5L22.8 32.1L22.3 38.5C22.7 38.5 23.1 38.3 23.6 37.9L26.6 35L32.8 39.6C34.1 40.3 34.8 39.9 35.1 38.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a4693ff6011202d82eaf960ae96c4ec8.svg";
export { ForwardRef as ReactComponent };